import React                from 'react';
import { Container, Group } from '@mantine/core';
import { AppMenuButtons }   from '@layouts/Menu/App/AppMenuButtons';
import { UserMenuButtons }  from '@layouts/Menu/User/UserMenuButtons';


export const UserMenu: React.FC = () => {

    return (
        <Container px={0}>
            <Group spacing={0}>
                <AppMenuButtons/>

                <UserMenuButtons/>
            </Group>
        </Container>
    );
};
